<script>
import Move from "./Move.vue";
export default {
  components: {
    Move,
  },
};
</script>


<style scoped>
.script-list {
  margin: 0;
  padding: 0;
  position: relative;
}
.pointer{
  position: absolute;
  top: 200px;
  left: 30vw;
}
.note{
  position: absolute;
  top: 120px;
  left: 30vw;
  text-align: center;
}
</style>

<template>
  <div class="script-list">
    <div class="note">
        <h3>This script is empty</h3>
        <p>Start adding a circuit by clicking "ADD CIRCUIT" below.</p>
    </div>
    <move></move>
    <move></move><move></move><move></move><move></move><move></move
    ><move></move><move></move><move></move><move></move><move></move>
    <svg xmlns="http://www.w3.org/2000/svg" width="91.358" height="209.269" viewBox="0 0 91.358 209.269" class="pointer">
  <g id="Dotted_arrow_bottom_left" data-name="Dotted arrow bottom left" transform="translate(74.447 0.365) rotate(21)">
    <g id="Polygon_1" data-name="Polygon 1" transform="translate(26.434 213.619) rotate(160)" fill="#fff">
      <path d="M 10.15435886383057 9.500021934509277 L 0.8456329107284546 9.500021934509277 L 5.499995708465576 1.037527203559875 L 10.15435886383057 9.500021934509277 Z" stroke="none"/>
      <path d="M 5.499995708465576 2.075052261352539 L 1.691269874572754 9.000021934509277 L 9.308721542358398 9.000021934509277 L 5.499995708465576 2.075052261352539 M 5.499995708465576 1.9073486328125e-06 L 10.99999618530273 10.00002193450928 L -4.76837158203125e-06 10.00002193450928 L 5.499995708465576 1.9073486328125e-06 Z" stroke="none" fill="#000"/>
    </g>
    <path id="Path_272" data-name="Path 272" d="M17.556,0S0,40.313,0,91.888,17.556,206.3,17.556,206.3" transform="translate(0 0)" fill="none" stroke="#000" stroke-width="1" stroke-dasharray="5"/>
  </g>
</svg>

  </div>
</template>